import { create } from 'zustand';

import type { AuthInfo, UserRole } from './types';

type AuthState = {
  accessToken?: string;
  role?: UserRole;
  isAuthenticated: boolean;
  setAuth: (data: AuthInfo) => void;
  clearAuth: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: undefined,
  role: undefined,
  isAuthenticated: false,
  setAuth: (data) => {
    set({
      accessToken: data.accessToken,
      role: data.role,
      isAuthenticated: true,
    });
  },
  clearAuth: () => {
    set({
      accessToken: undefined,
      role: undefined,
      isAuthenticated: false,
    });
  },
}));

export function getAccessToken() {
  return useAuthStore.getState().accessToken;
}

export function getRole() {
  return useAuthStore.getState().role;
}

export function setAuth(data: AuthInfo) {
  useAuthStore.getState().setAuth(data);
}

export function clearAuth() {
  useAuthStore.getState().clearAuth();
}
